import axios from "axios";

export const createStripeCustomer = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_MAIN_API}/stripe/customers`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
};

export const createStripeSubscription = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_MAIN_API}/stripe/subscriptions`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
};

export const createFieldRoutesCustomer = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_MAIN_API}/field-routes/customers`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        authenticationKey: process.env.REACT_APP_API_KEY,
        authenticationToken: process.env.REACT_APP_API_TOKEN,
      },
    }
  );
};
